import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClickhouseService } from '../../../../../shared/services/clickhouse.service';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../../../store/state/app.state';
import { combineLatest } from 'rxjs';
import {
  userNextDailyEdgeSelector,
  userSubscriptionTypeSelector,
} from '../../../../../store/selectors/billing.selectors';

@Component({
  selector: 'app-balance-message',
  templateUrl: './balance-message.component.html',
  styleUrls: ['./balance-message.component.scss'],
})
export class BalanceMessageComponent implements OnInit {
  hours: number = 0;

  minutes: number = 0;

  seconds: number = 0;

  subscriptionType: string = '';

  private nextDailyEdge: number = 0;

  constructor(
    private modalService: NgbModal,
    private clickHouse: ClickhouseService,
    private store: Store<AppStateInterface>,
  ) {
    combineLatest([
      this.store.select(userSubscriptionTypeSelector),
      this.store.select(userNextDailyEdgeSelector),
    ]).subscribe(([subscriptionType, nextDailyEdge]) => {
      this.subscriptionType = subscriptionType;
      this.nextDailyEdge = nextDailyEdge;
    });
  }

  ngOnInit(): void {
    this.timer();
  }

  continueClick() {
    import('../../../../../components/modals/billing-modal/billing-modal-component.module').then(
      ({ BillingModalComponentModule }) => {
        const BillingModalComponent = BillingModalComponentModule.getComponent();
        this.modalService.open(BillingModalComponent, {
          backdrop: 'static',
          keyboard: false,
        });
      },
    );
    this.clickHouse.storeEvent('message_get_more_coin_click').subscribe(() => {});
  }

  private timer() {
    const x = setInterval(() => {
      this.hours = Math.floor((this.nextDailyEdge % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.nextDailyEdge % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.nextDailyEdge % (1000 * 60)) / 1000);

      if (this.nextDailyEdge < 0) {
        clearInterval(x);
      }
      this.nextDailyEdge -= 1000;
    }, 1000);
  }
}
